<template>
    <tr
        :class="className"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ label }}
        </td>
        <td class="kgr-table__cell">
            <kgr-money :value="value1 / 100" />
        </td>
        <td class="kgr-table__cell">
            <kgr-money :value="value2 / 100" />
        </td>
    </tr>
</template>

<script>
import KgrMoney from '../../common/convert/Money';

export default {
    components: {
        'kgr-money': KgrMoney,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        value1: {
            type: Number,
            required: false,
            default: 0,
        },
        value2: {
            type: Number,
            required: false,
            default: 0,
        },
        className: {
            type: String,
            required: false,
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
